
import Vue, { PropType } from 'vue'

export type DataType = {
  timerId?: number;
  focused: boolean;
}

export default Vue.extend({
  name: 'BaseInputForm',

  props: {
    value: String as PropType<string>,
    label: String as PropType<string>,
    placeholder: String as PropType<string>,
  },

  data(): DataType {
    return {
      timerId: 0,
      focused: false,
    }
  },

  computed: {
    bindValue: {
      get (): string {
        this.searchAfterTwoSeconds()
        return this.value
      },

      set (value: string): void {
        this.$emit('input', value)
      }
    },
  },

  methods: {
    clearValue(): void {
      this.$emit('input', '')
    },

    clearTimerId(): void {
      this.timerId = undefined
    },

    searchAfterTwoSeconds(): void {
      if (this.timerId) {
        clearTimeout(this.timerId)
      }

      this.timerId = setTimeout(() => {
        this.emitToSearch()
      }, 2000)
    },

    emitToSearch(): void {
      this.$emit('search')
    },

    changeFocused(): void {
      this.focused = !this.focused
    }
  }
})
